// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__NveEU","imgContainer":"styles_imgContainer__BE_yP"};